/**
 * SIMPLE SMILE EMAIL SUBSCRIPTION
 * Watches for loyalty signup without relying on Smile object
 */

(function() {
  'use strict';
  
  console.log('[SmileEmail] Simple integration starting...');
  
  // Watch for ANY form submission
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Check if email field exists
    const emailField = form.querySelector('input[type="email"]');
    if (!emailField) return;
    
    // Check if this might be a Smile/loyalty form
    const formHTML = form.outerHTML.toLowerCase();
    const isLoyaltyForm = 
      formHTML.includes('smile') ||
      formHTML.includes('loyalty') ||
      formHTML.includes('points') ||
      formHTML.includes('rewards') ||
      form.closest('#smile-ui-container') ||
      form.closest('.smile-launcher-container');
    
    if (isLoyaltyForm) {
      console.log('[SmileEmail] Loyalty form detected, subscribing:', emailField.value);
      
      // Subscribe after a delay (let Smile process first)
      setTimeout(() => {
        fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `form_type=customer&utf8=✓&contact[accepts_marketing]=true&contact[email]=${emailField.value}&contact[tags]=loyalty-program`
        }).then(() => {
          console.log('[SmileEmail] Subscription request sent');
        });
      }, 1000);
    }
  }, true); // Use capture to catch all form submits
  
})();